import isNil from 'lodash/isNil';
import {
  IBuilder,
  IErrors,
  RowType,
} from '../../../../../redux/slices/oldBuilder';
import { assertCondition, assertNotNil } from '../../../../../utils/types';
import {
  MetricTypeKey,
  QueryType,
  SignificanceModeKey,
} from '../../../../../utils/apollo/graphqlSchema';
import { getErrorsFromCohortRows } from '../../../../../components/Builder/utils/getCohortRowErrorsByQueryType';
import { ISignificanceErrors } from '../../../../../redux/slices/oldBuilder/significance/types';

const validateSignificanceBuilder = (
  builderState: IBuilder,
): {
  builderErrors: IErrors;
  significanceErrors: ISignificanceErrors;
} => {
  const { selectedOptions, significance, globalCohorts } = builderState;
  const { criteria, metric } = significance;

  assertCondition(selectedOptions?.type === QueryType.Significance);
  assertNotNil(criteria);
  assertNotNil(metric);

  const builderErrors: IErrors = {
    // validate cohorts
    ...getErrorsFromCohortRows(globalCohorts, RowType.globalCohorts),
  };
  const errors: ISignificanceErrors = {};

  // validate criteria
  if (criteria.modeKey === SignificanceModeKey.Breakdown) {
    const { field, controlGroup, variants } = criteria;

    if (isNil(field)) {
      errors.criteriaField = true;
    } else {
      if (isNil(controlGroup)) {
        errors.controlGroup = true;
      }
      if (isNil(variants) || !variants.some((variant) => !isNil(variant))) {
        errors.criteriaVariant = true;
      }
    }
  } else if (criteria.modeKey === SignificanceModeKey.Segment) {
    const { controlGroup, variants } = criteria;

    if (isNil(controlGroup)) {
      errors.controlGroup = true;
    }
    if (isNil(variants) || !variants.some((variant) => !isNil(variant))) {
      errors.criteriaVariant = true;
    }
  } else if (criteria.modeKey === SignificanceModeKey.Experiment) {
    const { experimentId, controlGroup, variants } = criteria;

    if (isNil(experimentId)) {
      errors.criteriaField = true;
    } else {
      if (isNil(controlGroup)) {
        errors.controlGroup = true;
      }
      if (isNil(variants) || !variants.some((variant) => !isNil(variant))) {
        errors.criteriaVariant = true;
      }
    }
  }

  // validate metric
  if (metric.type === MetricTypeKey.Measure) {
    const { measure } = metric;

    if (isNil(measure)) {
      errors.metricMeasure = true;
    }
  } else if (metric.type === MetricTypeKey.Query) {
    const { analysisId } = metric;

    if (isNil(analysisId)) {
      errors.metricAnalysis = true;
    }
  } else if (metric.type === MetricTypeKey.Retention) {
    const { analysisId } = metric;

    if (isNil(analysisId)) {
      errors.metricAnalysis = true;
    }
  } else if (metric.type === MetricTypeKey.Funnel) {
    const { analysisId } = metric;

    if (isNil(analysisId)) {
      errors.metricAnalysis = true;
    }
  }

  return {
    builderErrors,
    significanceErrors: errors,
  };
};

export default validateSignificanceBuilder;
